import { HTTP } from "@/utils/http-common"

export default {
  async getAll() {
    const path = `/documents/`
    return (await HTTP.get(path)).data
  },

  async get(documentId) {
    const path = `/documents/${documentId}`
    return (await HTTP.get(path)).data
  },

  async post(data) {
    const path = `/documents/`
    return (await HTTP.post(path, data)).data
  },

  async patch(documentId, data) {
    const path = `/documents/${documentId}`
    return (await HTTP.patch(path, data)).data
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/documents/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(documentId) {
    const path = `/documents/${documentId}`
    return (await HTTP.delete(path)).data
  },

  pdf: {
    async get(documentId) {
      const path = `/documents/${documentId}/pdf`
      HTTP.get(path).then(response => {
        let blob = new Blob([response], { type: "application/pdf" })
        let link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = "Report_" + new Date() + ".pdf"
        link.click()
      })
    }
  },

  signatures: {
    async getAll(documentId) {
      const path = `/documents/${documentId}/signatures`
      return (await HTTP.get(path)).data
    },
    async post(documentId, imageData) {
      const path = `/documents/${documentId}/signatures`

      if (imageData) {
        // Si des données d'image sont fournies, utilisez une requête multipart pour envoyer l'image
        const formData = new FormData()
        formData.append("image", imageData)

        return (
          await HTTP.post(path, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
        ).data
      } else {
        // Sinon, si aucune image n'est fournie, effectuez une requête POST sans données d'image
        return (await HTTP.post(path)).data
      }
    }
    // async post(documentId) {
    //   const path = `/documents/${documentId}/signatures`
    //   return (await HTTP.post(path)).data
    // }
  },

  values: {
    async getAll(documentId) {
      const path = `/documents/${documentId}/values`
      return (await HTTP.get(path)).data
    },
    async put(documentId, data) {
      const path = `/documents/${documentId}/values`
      return (await HTTP.put(path, data)).data
    }
  }
}
